import * as React from 'react'

export interface SidePanelState {
  isRightSidePanelOpen: boolean
}

const SidePanelActionTypes = {
  OpenRightSidePanel: 'OpenRightSidePanel',
  CloseRightSidePanel: 'CloseRightSidePanel',
}

type AllowedSidePanelActionTypes = 'OpenRightSidePanel' | 'CloseRightSidePanel'

type SidePanelAction = {
  type: AllowedSidePanelActionTypes
}

export interface SidePanelContextState {
  state: SidePanelState
  dispatch: (action: SidePanelAction) => void
}

const DEFAULT_SIDEPANEL_STATUS: SidePanelContextState = {
  state: {
    isRightSidePanelOpen: false,
  } as SidePanelState,
  dispatch: (action: SidePanelAction) => {},
}

const reducer = (state: SidePanelState, action: SidePanelAction) => {
  switch (action.type) {
    case SidePanelActionTypes.OpenRightSidePanel:
      return {
        ...state,
        isRightSidePanelOpen: true,
      }
    case SidePanelActionTypes.CloseRightSidePanel:
      return {
        ...state,
        isRightSidePanelOpen: false,
      }
    default:
      return state
  }
}

// TODO: save off with session or local storage
export const getInitialSidePanelStatus = () => DEFAULT_SIDEPANEL_STATUS.state

export const SidePanelContext = React.createContext<SidePanelContextState>(
  DEFAULT_SIDEPANEL_STATUS,
)

type SidePanelContextProviderProps = {
  children: any
}

export const SidePanelContextProvider: React.FunctionComponent<SidePanelContextProviderProps> = ({
  children,
}) => {
  const initialSidePanelState = getInitialSidePanelStatus()
  const [state, dispatch] = React.useReducer(reducer, initialSidePanelState)
  const value = { state, dispatch }

  return (
    <SidePanelContext.Provider value={value}>
      {children}
    </SidePanelContext.Provider>
  )
}

export const SidePanelContextConsumer = SidePanelContext.Consumer
